import { SvgIcon, SxProps } from "@mui/material";
import PenSolid from "jsx:../../../Images/Icons/FontAwesome/solid/pen.svg";

export function PenSolidIcon(props: SxProps) {
    return <SvgIcon component={PenSolid} inheritViewBox sx={props} />;
}
